import React from 'react';
import { useHistory } from 'react-router-dom';
import { Block, Heading, Icon } from '../../../../../../components';
import { SaveButton } from '../components/styled';
import Spinner from '../../../../../../components/Spinner';
import {
  ContainerProcedureBse,
  Step,
  BlockBse,
  ContainerCard
} from './components';
import chevronRigthIcon from '../../../../../../../assets/icons/chevron-right-blue.svg';
import SuccessIcon from '../../../../../../../assets/icons/bse/icon-success.svg';
import { CommonBlock } from '../../../requests/IssuanceUniversityCard/Register/components/styled';
import { Description } from '../forms/index/styled';
import CardInProgress from './components/CardInProgress';
import SwornDeclaration from '../components/swornDeclaration/components/SwornDeclaration';
import Processing from '@/presentation/components/Processing';
import RequestState from '../components/RequestStateCard';
import DateHelpers from '../../../../../../../core/helpers/DateHelper';
import constants from '@/presentation/modules/procedures/constants';
import CardProgress from '@/presentation/reusables/CardProgress';
import documentFailedImage from '../../../../../../../assets/illustrations/procedures/cards/document-failed.svg';
import documentFailedDskImage from '../../../../../../../assets/illustrations/procedures/cards/document-failed-dsk.svg';
import { ToggleHeader } from '../../../certificates-constancies/type1/register/components';
import BSEContent from '../home/Components/BSEContent';
import BSEPinone from '../home/Components/BSEPinone';
import BSEPintwo from '../home/Components/BSEPintwo';
import { BodyContent, Container } from '../home/Components/bseStyle';
import BSEFooter from '../home/Components/BSEFooter';
import Modal from '@/presentation/modules/procedures/components/Modal/Modal';
import ContentModalTwoButtons from '@/presentation/modules/procedures/components/ContentModalTwoButtons';
import ModuleContainer from '@/presentation/components/Container';
import Back from '@/presentation/reusables/Button/Back';

interface IProps {
  procedure: any;
  loadingFormBSE: boolean;
  loadingPayment: boolean;
  successActivatePay: boolean;
  handlerNextStep: (key: 'forms' | 'documents') => void;
  handlerCompleteForm: (key: 'forms' | 'documents') => void;
  formIsCompleted?: boolean;
  formDocumentIsCompleted?: boolean;
  showModal: boolean;
  handlerCloseModal: () => void;
  handlerStepAction: () => void;
  handlerRedirect: () => void;
  handlerOkModal: () => void;
  handleSend: () => void;
  loadingProcessBSE: any;
  stepStatus: any[];
  dataValidate: {
    status: string;
    paymentActivated: boolean;
    payed: boolean;
  };
  finalStateBse: {
    commentary: string;
    dateRequest: number;
    dateFinalized: number;
    discount: string;
    expirationDate: number;
    isLastAttempt: boolean;
  };
  fromProgress?: boolean;
  deleteUploadedFile: (ids: number[]) => void;
  sendDocuments: (data: any) => void;
  downloadUploadedFile: (path: string) => void;
  aditionalDocuments: any[];
  isValidDocuments: boolean;
  setIsValidDocuments: (isValid: boolean) => void;
  requestSteps?: any[];
  isLoadingUpdateFiles: boolean;
  request?: any;
  onBack: () => void;
}

const RegisterBaseView = ({
  formDocumentIsCompleted,
  formIsCompleted,
  handlerCompleteForm,
  handlerNextStep,
  loadingFormBSE,
  loadingPayment,
  successActivatePay,
  procedure,
  showModal,
  handlerCloseModal,
  handlerStepAction,
  handlerRedirect,
  handlerOkModal,
  handleSend,
  loadingProcessBSE,
  stepStatus,
  dataValidate,
  finalStateBse,
  fromProgress,
  deleteUploadedFile,
  sendDocuments,
  downloadUploadedFile,
  aditionalDocuments,
  isValidDocuments,
  setIsValidDocuments,
  requestSteps,
  isLoadingUpdateFiles,
  request,
  onBack
}: IProps) => {
  const history = useHistory();
  const evalStatus = () =>
    constants.procedureStatus.bse.find(
      (s: any) => s.name === request?.status.status
    );

  return (
    <ModuleContainer
      containerType="subsection"
      data-testid="cmp-RegisterBseView"
    >
      <Processing isOpen={loadingPayment} />
      <Modal
        show={showModal && !loadingPayment}
        handleClose={handlerCloseModal}
      >
        <ContentModalTwoButtons
          img={undefined}
          title={
            !dataValidate.paymentActivated
              ? '¿Estás seguro de activar el pago?'
              : '¡Listo! Se ha creado el pago'
          }
          subtitle={
            !dataValidate.paymentActivated
              ? `Al aceptar, se cargará el monto de S/ ${procedure?.amount}.00 a tus pagos pendientes.`
              : 'Ya se encuentra disponible tu pago. Recuerda que una vez realizado el pago procederá tu solicitud.'
          }
          showInfo={false}
          textButton1={
            !dataValidate.paymentActivated ? 'Sí, actívalo' : 'Ir a pagos'
          }
          onClickButton1={handlerOkModal}
          textButton2={
            !dataValidate.paymentActivated ? 'Cancelar' : 'Lo haré después'
          }
          onClickButton2={handlerCloseModal}
        />
      </Modal>
      <BlockBse>
        <div style={{ paddingTop: 16 }}>
          <Back
            dataTestid="cmp-buttom-back-refactor"
            onClick={() => {
              if (fromProgress) onBack();
              else history.goBack();
            }}
          />
        </div>
      </BlockBse>
      <ContainerProcedureBse>
        <Block customized alignItems="center" justifyContent="center">
          {(!procedure || loadingFormBSE) && <Spinner />}
          {procedure && !loadingFormBSE && (
            <BlockBse>
              <ToggleHeader
                name={procedure.name}
                amount={procedure.amount}
                duration={procedure.duration}
                date={procedure.endDate}
                status={request?.status}
                childContent={
                  <Container>
                    <BodyContent>
                      <BSEPinone
                        PropPinOne={procedure.pin2}
                        paddingTopBoddyTitle="0px"
                        marginBodyTitle="0px"
                      />
                      <BSEContent marginBodyContent2="12px 0px 0px 0px" />
                      <BSEPintwo
                        PropPinTwo={procedure.pin1}
                        marginIconArrow="0px"
                      />
                      <BSEFooter />
                    </BodyContent>
                  </Container>
                }
              />
              <Heading
                text="Progreso"
                level={2}
                color="var(--text-text02)"
                size={18}
                lineHeight={28}
                fontWeight="900"
                className=""
                align="flex-start"
              />
              <CommonBlock>
                <Step
                  name={procedure.steps[1].name}
                  order={procedure.steps[1].order}
                  disabled={
                    evalStatus()?.name === 'ANULADO'
                      ? true
                      : stepStatus[0].disable
                  }
                  isCurrent={stepStatus[0].current}
                  isComplete={stepStatus[0].complete}
                >
                  {evalStatus()?.name !== 'ANULADO' &&
                    (!stepStatus[0].complete ? (
                      <CardInProgress
                        activatePayment={!dataValidate.paymentActivated} // estados excluyentes
                        paymentActivated={dataValidate.paymentActivated} // estados excluyentes
                        isSuccessActivatePayment={successActivatePay}
                        onClickActivate={handlerStepAction}
                        onClickActivated={handlerRedirect}
                        availableDays={procedure?.duration}
                      />
                    ) : (
                      <div
                        style={{
                          position: 'absolute',
                          top: 2,
                          color: '#161D1F',
                          fontSize: 12
                        }}
                      >
                        {requestSteps?.[0]?.date?.toLowerCase()}
                      </div>
                    ))}
                </Step>
                <Step
                  name={procedure.steps[0].name}
                  order={procedure.steps[0].order}
                  disabled={stepStatus[1].disable}
                  isCurrent={stepStatus[1].current}
                  isComplete={
                    evalStatus()?.name === 'ANULADO'
                      ? true
                      : stepStatus[1].complete
                  }
                >
                  {evalStatus()?.name !== 'ANULADO' &&
                    !stepStatus[1].complete && (
                      <ContainerCard>
                        <p>
                          Completa el siguiente paso para registrar tu
                          expediente:
                        </p>
                        <div className="complete__form">
                          <button
                            data-testid="btn-complete-form-cmp"
                            className="complete__form--btn fadeTransition"
                            type="button"
                            onClick={() => handlerCompleteForm('forms')}
                          >
                            <div className="complete__form--wrapper">
                              {formIsCompleted === undefined && (
                                <Icon name="file-pen" size={20} />
                              )}
                              {formIsCompleted === false && (
                                <Icon
                                  name="alert-circle"
                                  size={20}
                                  color="#E8212B"
                                />
                              )}
                              {formIsCompleted === true && (
                                // <Icon name="file" size={20} />
                                <img src={SuccessIcon} alt="SuccessIcon" />
                              )}
                              <Description>Completar formularios</Description>
                            </div>
                            <img
                              src={chevronRigthIcon}
                              alt="chevronRigthIcon"
                            />
                          </button>
                        </div>
                        <SaveButton
                          disabled={
                            formIsCompleted === undefined
                              ? true
                              : !formIsCompleted || !dataValidate.payed
                          }
                          onClick={() => {
                            handlerNextStep('forms');
                          }}
                          data-testid="cmp-save-bse-form"
                        >
                          Siguiente
                        </SaveButton>
                      </ContainerCard>
                    )}
                </Step>
                <Step
                  name={procedure.steps[2].name}
                  order={procedure.steps[2].order}
                  disabled={
                    evalStatus()?.name === 'ANULADO'
                      ? false
                      : stepStatus[2].disable
                  }
                  isCurrent={stepStatus[2].current}
                  isComplete={
                    evalStatus()?.name === 'ANULADO'
                      ? true
                      : stepStatus[2].complete
                  }
                >
                  {stepStatus[2].disable || stepStatus[2].complete ? (
                    <></>
                  ) : (
                    <ContainerCard>
                      <p>
                        Completa el siguiente paso para registrar tu expediente:
                      </p>
                      <div className="complete__form">
                        <button
                          data-testid="cmp-completeform-id"
                          className="complete__form--btn fadeTransition"
                          type="button"
                          onClick={() => handlerCompleteForm('documents')}
                        >
                          <div className="complete__form--wrapper">
                            {formDocumentIsCompleted === undefined && (
                              <Icon name="file-pen" size={20} />
                            )}
                            {formDocumentIsCompleted === false && (
                              <Icon name="upload" size={20} color="#283044" />
                            )}
                            {formDocumentIsCompleted === true && (
                              // <Icon name="file" size={20} />
                              <img src={SuccessIcon} alt="SuccessIcon" />
                            )}
                            <Description>Subir documentos</Description>
                          </div>
                          <img src={chevronRigthIcon} alt="chevronRigthIcon" />
                        </button>
                      </div>
                      <SaveButton
                        disabled={!formDocumentIsCompleted}
                        onClick={() => handlerNextStep('documents')}
                        data-testid="cmp-save-bse-form"
                      >
                        Siguiente
                      </SaveButton>
                    </ContainerCard>
                  )}
                </Step>
                <Step
                  name={procedure.steps[3].name}
                  order={procedure.steps[3].order}
                  disabled={
                    evalStatus()?.name === 'ANULADO'
                      ? false
                      : stepStatus[3].disable
                  }
                  isCurrent={stepStatus[3].current}
                  isComplete={
                    evalStatus()?.name === 'ANULADO'
                      ? true
                      : stepStatus[3].complete
                  }
                >
                  {stepStatus[3].disable || stepStatus[3].complete ? (
                    <div
                      style={{
                        position: 'absolute',
                        top: 2,
                        color: '#161D1F',
                        fontSize: 12
                      }}
                    >
                      {requestSteps?.[3]?.date?.toLowerCase()}
                    </div>
                  ) : (
                    <ContainerCard>
                      <div className="complete__form--wrapper">
                        <SwornDeclaration handleSend={handleSend} />
                      </div>
                      {/* <SwornDeclaration handleSend={handleSend} /> */}
                    </ContainerCard>
                  )}
                </Step>

                <Processing
                  isOpen={loadingProcessBSE || isLoadingUpdateFiles}
                />
                <Step
                  name={procedure?.steps[4]?.name}
                  order={procedure?.steps[4]?.order}
                  disabled={
                    evalStatus()?.name === 'ANULADO'
                      ? false
                      : stepStatus[4].disable
                  }
                  isCurrent={stepStatus[4].current}
                  isComplete={
                    evalStatus()?.name === 'ANULADO'
                      ? true
                      : stepStatus[4].complete
                  }
                  isLast
                >
                  {stepStatus[4].disable ? (
                    <></>
                  ) : (
                    <RequestState
                      reqState={dataValidate.status}
                      reqDate={DateHelpers.formatDate(
                        finalStateBse.dateRequest
                      )}
                      reqStaffText={finalStateBse?.commentary}
                      approvedBsePercentage={finalStateBse?.discount}
                      expirationDate={finalStateBse?.expirationDate}
                      isLastAttempt={finalStateBse?.isLastAttempt}
                      // Los props a continuación son para el FileUpload
                      deleteUploadedFile={(ids) => deleteUploadedFile(ids)}
                      sendDocuments={(data) => sendDocuments(data)}
                      downloadUploadedFile={downloadUploadedFile}
                      aditionalDocuments={aditionalDocuments}
                      isValidDocuments={isValidDocuments}
                      setIsValidDocuments={setIsValidDocuments}
                    />
                  )}
                  {evalStatus()?.name === 'ANULADO' && (
                    <>
                      {procedure?.steps[2]?.date && (
                        <div style={{ paddingBottom: '8px' }}>
                          {procedure?.steps[4]?.date}
                        </div>
                      )}
                      <CardProgress
                        image={[documentFailedImage, documentFailedDskImage]}
                        title={`Tu solicitud se ha anulado`}
                        subtitle="No pagaste a tiempo el monto de tu trámite."
                      />
                    </>
                  )}
                </Step>
              </CommonBlock>
            </BlockBse>
          )}
        </Block>
      </ContainerProcedureBse>
    </ModuleContainer>
  );
};

RegisterBaseView.default = {
  fromProgress: false,
  requestSteps: []
};

export default RegisterBaseView;
